module.exports = __webpack_public_path__ + "assets/tutorials/Selecting_an_Audience.png";